<template>
  <div class="form1">
    <h2>关卡谜题提示</h2>
    <br />
    <el-button
      size="large"
      style="background: #409eff; color: #fff"
      @click="addTip(this.detailId)"
      >新增提示</el-button
    >
    <br />
    <br />

    <VueDraggable ref="el" v-model="fileList2" class="content">
      <div
        v-for="(item, index) in fileList2"
        :key="index"
        class="lunBo"
        @click="changeTip(index)"
        :style="item.active == true ? 'background:#9a9a9a' : 'background:black'"
      >
        {{ `提示${item.key + 1}` }}

        <span @click="deleteTip(index, $event)">X</span>
      </div>
    </VueDraggable>
    <br />
    <br />
    <div class="story">
      <div class="panel">
        <div class="panel_left">
          <el-form
            :model="form"
            label-width="auto"
            style="max-width: 600px"
            label-position="top"
            :rules="rules"
            ref="ruleForm"
            status-icon
          >
            <el-form-item label="谜题提示标题" prop="puzzleTitle">
              <el-input v-model="form.puzzleTitle" size="large" />
            </el-form-item>
            <el-form-item label="谜题提示内容" prop="puzzleContent">
              <el-input
                v-model="form.puzzleContent"
                type="textarea"
                size="large"
                rows="10"
                maxlength="1000"
                show-word-limit
              />
            </el-form-item>
            <el-form-item label="谜题提示图片" prop="puzzleCover">
              <el-upload
                class="avatar-uploader"
                :action="UpdateApi"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList"
                :disabled="allowUpload"
              >
                <el-image
                  :src="form.puzzleCover"
                  v-if="form.puzzleCover"
                  class="avatar"
                  alt=""
                  :fit="'contain'"
                >
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="allowUpload">
              <el-button type="warning" @click="clearImage">{{
                $t("settings.clearImg")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="panel_right">
          <p class="title">App示意图</p>
          <div class="example1">
            <p>
              <span
                ><el-icon size="20"><ArrowLeft /></el-icon
              ></span>
              <span>提示</span>
              <span
                ><el-icon size="20"><ArrowRight /></el-icon
              ></span>
            </p>
            <p>
              {{ form.puzzleTitle }}
            </p>
            <p v-show="showTip">
              <img :src="form.puzzleCover" alt="" />
              <span style="white-space: pre-wrap">{{
                form.puzzleContent
              }}</span>
            </p>
            <p v-show="!showTip">
              <el-icon size="220"><QuestionFilled /></el-icon>
            </p>
            <p @click="showTip = !showTip">开启提示</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
  reactive,
} from "vue";
import {
  ArrowLeft,
  ArrowRight,
  Plus,
  QuestionFilled,
} from "@element-plus/icons-vue";
import {
  ElMessage,
  ElNotification,
  FormRules,
  UploadProps,
} from "element-plus";
import { VueDraggable } from "vue-draggable-plus";
const validateNotEmpty = (rule: any, value: string, callback: any) => {
  if (value.trim() === "") {
    callback(new Error(rule.message));
  } else {
    callback();
  }
};
interface Data {
  title: string;
  counter: number;
  message: string;
  data: any;
  loading: boolean;
  error: string;
  boxRef: HTMLElement | null;
}

export default defineComponent({
  name: "App",
  components: { ArrowLeft, ArrowRight, QuestionFilled, Plus, VueDraggable },
  props: ["dataForm"],
  data(): any {
    return {
      form: {
        puzzleTitle: "",
        puzzleContent: "",
        puzzleCover: "",
      },
      fileList: [],
      fileList2: [],
      dialogImageUrl: "",
      dialogVisible: false,
      showTip: false,
      detailId: "",
      activeIndex: 0,
      rules: reactive<FormRules>({
        puzzleTitle: [
          {
            required: true,
            message: "故事标题不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        puzzleContent: [
          {
            required: true,
            message: "故事封面不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
      }),
    };
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return this.form.puzzleCover !== "" && this.form.puzzleCover !== null;
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        if (this.fileList2[this.activeIndex]) {
          // 检查 fileList2[this.activeIndex] 是否存在
          this.fileList2[this.activeIndex].tipTitle = this.form.puzzleTitle;
          this.fileList2[this.activeIndex].tipContent = this.form.puzzleContent;
          this.fileList2[this.activeIndex].tipPicture = this.form.puzzleCover;
        }
      },
      immediate: true,
      deep: true, // 可以深度检测到 person 对象的属性值的变化
    },
    message(newVal: string, oldVal: string) {
      console.log(`Message changed from "${oldVal}" to "${newVal}"`);
    },
    dataForm: {
      immediate: true, // 组件挂载时立即触发
      deep: true, // 深度监听，捕获对象内部属性变化
      handler(newVal) {
        if (newVal && newVal.tips) {
          this.getTipList(newVal.tips);
        }
      },
    },
  },
  mounted() {
    const { id, detailId } = this.$route.params;

    this.detailId = detailId;

    // setTimeout(() => {
    //   this.getTipList(this.dataForm.tips);
    // }, 200);
  },
  methods: {
    handleSave() {
      const { updateTime, ...formWithoutUpdateTime } = this.form;

      this.$store
        .dispatch("game/updateGame", { gameBean: formWithoutUpdateTime })
        .then((res: any) => {})
        .catch(() => {});
    },
    fetchGameList(tips: string) {
      this.$store
        .dispatch("game/getTipList", { tips: tips })
        .then((res: any) => {
          console.log(res);
        })
        .catch((err: any) => {
          console.log(err);
        });
    },

    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      // Display uploaded avatar
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.puzzleCover = reader.result as string;
      };

      return true;
    },
    handleAvatarSuccess(response: any) {
      this.form.puzzleCover = response.data.returnFileUrl;
    },
    handlePictureCardPreview(uploadFile: any): UploadProps["onPreview"] | void {
      this.dialogImageUrl = uploadFile.url!;
      this.dialogVisible = true;
    },
    handleRemove(
      uploadFile: any,
      uploadFiles: any
    ): UploadProps["onRemove"] | void {
      console.log(uploadFile, uploadFiles);
    },
    clearImage() {
      this.form.puzzleCover = "";
      this.fileList = [];
    },
    addTip(belongId: string) {
      if (this.fileList2.length >= 4) {
        ElMessage.warning({
          message: "最大提示数为4个",
        });
        return;
      }

      this.$store
        .dispatch("game/addTip", { belongId: belongId })
        .then((res: any) => {
          res.key = this.fileList2.length;
          this.fileList2.push(res);
        })
        .catch((err: any) => {
          console.log(err);
        });
    },
    getTipList(ids: string) {
      this.$store
        .dispatch("game/getTipList", { tips: ids })
        .then((res: any) => {
          const res2 = res.map((item, index) => {
            item.key = index;
            item.active = false;
            return item;
          });
          this.fileList2.push(...res2);
          if (this.fileList2.length != 0) {
            this.changeTip(0);
          }
        })
        .catch((err: any) => {
          console.log(err);
        });
    },
    changeTip(index: number) {
      this.fileList2.forEach((item, index) => {
        item.active = false;
      });
      this.fileList2[index].active = true;

      this.activeIndex = index;
      this.form.puzzleTitle = this.fileList2[index].tipTitle;
      this.form.puzzleContent = this.fileList2[index].tipContent;
      this.form.puzzleCover = this.fileList2[index].tipPicture;
    },

    deleteTip(index: number, event: Event) {
      event.stopPropagation();
      const tipId = this.fileList2[index].id;

      this.$store
        .dispatch("game/delTip", {
          levelId: this.detailId,
          tipId: tipId,
        })
        .then((res: any) => {
          this.fileList2 = this.fileList2.filter((item) => {
            return item.id != tipId;
          });

          if (this.activeIndex == index) {
            this.form.puzzleTitle = "";
            this.form.puzzleContent = "";
            this.form.puzzleCover = "";
          }
        });
    },

    saveTip() {
      const tipIds = this.fileList2
        .map((item) => {
          return item.id;
        })
        .join(",");

      this.$store
        .dispatch("game/updateTip", {
          levelId: this.detailId,
          ids: tipIds,
          tips: this.fileList2,
        })
        .then((res: any) => {
          console.log(res);
        })
        .catch((err: any) => {
          console.log(err);
        });
    },
  },
});
</script>

<style lang="less" scoped>
.panel {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &_left {
    width: 50%;
  }

  &_right {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;

    .title {
      margin-bottom: 20px;
      font-size: 1vw;
    }

    .example1 {
      width: 300px;
      height: 550px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      position: relative;
      box-sizing: border-box;
      padding: 14px;

      p {
        &:nth-child(1) {
          width: 100%;
          height: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          span {
            display: block;
          }
        }
        &:nth-child(2) {
          width: 100%;
          height: auto;
          margin-top: 30px;
        }
        &:nth-child(3) {
          width: 100%;
          height: 360px;
          overflow-y: scroll;
          box-sizing: border-box;
          padding: 14px;

          img {
            width: 60%;
            margin-left: 20%;
          }
          span {
            display: block;
            width: 100%;
            height: auto;
          }
        }
        &:nth-child(4) {
          width: 100%;
          height: 360px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &:nth-child(5) {
          width: 60%;
          height: 50px;
          background: rgb(45, 168, 224);
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: auto;
          margin-top: 15px;
        }
      }
    }
  }
}

.box {
  width: 100px;
  height: 100px;
}

.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}

、.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar-uploader {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader:hover {
  border-color: var(--el-color-primary);
}

.content {
  width: 100%;
  height: auto;
  max-width: 600px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  .lunBo {
    width: 120px;
    height: 50px;
    background: #000000;
    margin-left: 10px;
    margin-top: 10px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: move;
    position: relative;

    span {
      position: absolute;
      right: 14%;
      top: 36%;
      font-weight: bold;

      &:hover {
        color: rgb(20, 117, 213);
        transform: scale(1.5);
      }
    }
  }
}
</style>
